export const baseURL = import.meta.env.VITE_API_BASE_URL;
export const posthogKey = import.meta.env.VITE_APP_PUBLIC_POSTHOG_KEY;
export const posthogHost = import.meta.env.VITE_APP_PUBLIC_POSTHOG_HOST;
export const CSVDownloadUrl = import.meta.env.VITE_CSV_DOWNLOAD_URL;
export const WBSCSVDownloadUrl = import.meta.env.VITE_WBS_CSV_DOWNLOAD_URL;
export const WBSRISKCSVDownloadUrl = import.meta.env.VITE_WBS_RISK_CSV_DOWNLOAD_URL;
export const googleCredentialsClientId = import.meta.env.GOOGLE_CLIENT_ID;
export const smartElementKey = import.meta.env.SMART_ELEMENT_KEY;
export const tawkPropertyid = import.meta.env.VITE_APP_PUBLIC_TAWK_PROPERTYID;
export const tawkWidgetid = import.meta.env.VITE_APP_PUBLIC_TAWK_WIDGETID;
export const stripeKey = import.meta.env.VITE_APP_STRIPE_KEY;
export const msalClientId = import.meta.env.VITE_MSAL_CLIENT_ID;
export const msalTenatId = import.meta.env.VITE_MSAL_TENANT_ID;
export const msalSecretId = import.meta.env.VITE_MSAL_SECRET_ID;
export const appUrl = import.meta.env.VITE_APP_URL;
export const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY
export const requestURLs = {
  rootAuth: `${baseURL}/api/auth/root-auth`,
  login: `${baseURL}/api/auth/login`,
  signup: `${baseURL}/api/auth/sign-up`,
  project: `${baseURL}/api/project`,
  projectWithoutCalulationQuery: `${baseURL}/api/project/project-no-calulation`,
  organisation: `${baseURL}/api/organisation`,
  userUpdateProfile: `${baseURL}/api/user/`,
  updateUserOrganisationSettings: `${baseURL}/api/user/organisation/`,
  me: `${baseURL}/api/user/me`,
  verifyEmail: `${baseURL}/api/user/verify-email`,
  resendVerifyEmailOtp: `${baseURL}/api/user/resend-otp`,
  forgotPassword: `${baseURL}/api/auth/forgot-password`,
  resetPassword: `${baseURL}/api/auth/reset-password`,
  task: `${baseURL}/api/task/`,
  fileUpload: `${baseURL}/api/user/avatarImg-update`,
  changePassword: `${baseURL}/api/user/change-password`,
  notification: `${baseURL}/api/notification/`,
  kanbanColumn: `${baseURL}/api/project/kanban-column/`,
  logOut: `${baseURL}/api/auth/logOut`,
  refreshToken: `${baseURL}/api/auth/access-token`,
  adminPortfolioDashboardData: `${baseURL}/api/dashboard/administartorProjects`,
  managerPortfolioDashboardData: `${baseURL}/api/dashboard/projectManagerProjects`,
  teamMemberPortfolioDashboardData: `${baseURL}/api/dashboard/teamMemberProjects`,
  projectDashboardData: `${baseURL}/api/dashboard/dashboardByProjectId`,
  ip: `${baseURL}/api/auth/my-ip`,
  paymentCheckout: `${baseURL}/api/payment/checkout-session`,
  paymentUpgradeToEnterprise: `${baseURL}/api/payment/upgrade`,
  paymentStatus: `${baseURL}/api/payment/check-status/`,
  paymentInvoice: `${baseURL}/api/payment/invoice/`,
  paymentInvoicePortal: `${baseURL}/api/payment/invoice-portal`,
  risk: `${baseURL}/api/risk/`,
  ribbon: `${baseURL}/api/ribbon`,
  setting: `${baseURL}/api/setting`,
  paymentSubscription: `${baseURL}/api/payment/subscription/`,
  createAppClient: `${baseURL}/api/v1/create-token/`,
  removeAppClient: `${baseURL}/api/v1/token/`,
  appClient: `${baseURL}/api/v1/tokens/`,
  wbsTask: `${baseURL}/api/wbs-task/`,
  wbsRisk: `${baseURL}/api/wbs-risk/`,
  collaboratorVerificationToken: `${baseURL}/api/auth/collaborator-token/`,
  availability:`${baseURL}/api/availability/`,
  capacityPlanning: `${baseURL}/api/project/capacity-planning`,
};
